import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React from 'react';
import styled from 'styled-components';
import { TableHead, TableHeaderStyle, TableStyle, TableHeaderCell, TableBody, TableRow, TableCell } from './Table.styles.js';

const TableHeader = styled(function TableHeader(props) {
    const { className, children } = props;
    return (jsx(TableHead, Object.assign({ className: className }, { children: jsx(TableHeaderStyle, { children: children }) })));
}) ``;
const TableComponent = styled(function TableComponent(props) {
    const { className, children, evenColumns, hideHeader, 'data-testid': dataTestId, } = props;
    return (jsx(TableStyle, Object.assign({ className: className, "data-testid": dataTestId, "$evenColumns": evenColumns, "$hideHeader": hideHeader }, { children: children })));
}) ``;
function Table(props) {
    const { header, items, renderItem, renderItemKey } = props, tableProps = __rest(props, ["header", "items", "renderItem", "renderItemKey"]);
    return (jsxs(TableComponent, Object.assign({}, tableProps, { children: [jsx(TableHeader, { children: header.map(({ label, customCell: TableCell = TableHeaderCell }, index) => (jsx(TableCell, { children: label }, index))) }), jsx(TableBody, { children: items.map((item, index) => (jsx(React.Fragment, { children: renderItem(item) }, (renderItemKey === null || renderItemKey === void 0 ? void 0 : renderItemKey(item)) || index))) })] })));
}
const TableComponents = {
    Table: TableComponent,
    TableHeader,
    TableHeaderCell,
    TableBody,
    TableRow,
    TableCell,
};

export { Table, TableComponents };
